import type { PropsWithChildren } from 'react';
import React from 'react';

import Icons, { IconName } from '@/core/components/Icons';
import { IconColor, IconWeight } from '@/core/components/Icons/Icons';

interface SystemMessageProps extends PropsWithChildren {
  iconColor?: IconColor;
  iconName?: IconName;
  iconWeight?: IconWeight;
  message?: string;
}

const SystemMessage: React.FC<SystemMessageProps> = ({ message, children, iconName, iconColor, iconWeight }) => (
  <div className="semi-bold mx-auto w-full rounded-2 border border-solid border-stroke-primary p-3 text-center text-12 text-content-primary lg:w-82">
    {iconName && <Icons icon={iconName} className="mx-auto mb-2" color={iconColor} weight={iconWeight} />}
    {message && <p className="font-semibold">{message}</p>}
    {children}
  </div>
);

export default SystemMessage;
